import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { Radio } from '@dojo/widgets/radio';
import css from '../css/form.m.css';
class LikertHead extends I18nThemed {
    render() {
        const { heads } = this.properties;
        const kids = heads.map((hd, key) => v('th', { key }, [hd]));
        return v('thead', {}, [v('th', { key: 'blank' }), ...kids]);
    }
}
class LikertRow extends I18nThemed {
    render() {
        const { name: nm, question, answers, index, formdata } = this.properties;
        const name = `${nm}.${index}`;
        const kids = answers.map((ans, idx) => {
            const value = `${index + 1}: ${ans}`;
            const key = `ans-${index}-${idx}`;
            const checked = formdata[nm][index] === value;
            return v('td', { key }, [
                w(Radio, {
                    key: `radio-${index}-${idx}`,
                    name,
                    value,
                    aria: {
                        label: value,
                        checked: `${checked}`,
                        role: 'radio'
                    },
                    checked: checked,
                    onValue: (checked) => {
                        if (checked) {
                            formdata[nm][index] = value;
                        }
                        this.invalidate();
                    }
                })
            ]);
        });
        const cls = index % 2 === 1 ? 'odd' : 'even';
        return v('tr', { key: `row-${index}`, classes: [cls] }, [
            v('td', { key: `question-${index}` }, [question]),
            ...kids
        ]);
    }
}
class LikertBody extends I18nThemed {
    render() {
        const { name, questions, answers, formdata } = this.properties;
        if (formdata[name] === undefined || formdata[name] === null) {
            formdata[name] = new Array(questions.length).fill('');
        }
        const kids = questions.map((question, index) => w(LikertRow, { question, index, answers, name, formdata }));
        return v('tbody', {}, kids);
    }
}
let FormLikert = class FormLikert extends I18nThemed {
    render() {
        const { id: name, likertQuestions, likertAnswers, title, formdata } = this.properties;
        return v('fieldset', { classes: [this.theme(css.formLikert)] }, [
            v('legend', {}, [title]),
            v('table', { classes: ['likert', 'listing'] }, [
                w(LikertHead, { heads: likertAnswers }),
                w(LikertBody, { name, questions: likertQuestions, answers: likertAnswers, formdata })
            ])
        ]);
    }
};
FormLikert = __decorate([
    theme(css)
], FormLikert);
export { FormLikert };
